import { MedicalItem } from "./MedicalItem";

class MedicalItemRiskFactor extends MedicalItem {
    public ExposureDetails: string;
    public Name: string;
    public RiskFactorCodeId: string;
    public AgeAtTermination: number;
    public EndDate: Date;
    public PrecisionEndDate: number;
    public Details: string;

    public constructor(init?: Partial<MedicalItemRiskFactor>) {
        super();
        Object.assign(this, init);
    }
}

export { MedicalItemRiskFactor };
